import { SET_INITIAL_EFORMS, SET_INITIAL_TOTAL, ADD_ADITIONAL_EFORMS,SET_EFORM_TEMPLATES, CHANGE_EFORMS, SET_EFORM_SELECTED, SET_INITIAL_FOLDERS, SET_ENABLE_PICKUP, DELETE_PICKUP, EDIT_PICKUP, SET_INITIAL_EFORM_CREATE, SET_INITIAL_EFORM_JWT, UPDATE_NONPICKUP_EFORM, SET_INITIAL_EFORM_AUTOCOMPLETE,SET_INITIAL_EFORM_PAIS,SET_INITIAL_URL_S3 } from "./mutations-types";
import { map, extend } from 'underscore'

const mutations = {
  [SET_INITIAL_EFORMS]: (state, payload) => {
    state.eforms = payload
  },
  [SET_EFORM_TEMPLATES]: (state, payload) => {
    state.templatesEform = payload
  },
  [SET_INITIAL_TOTAL]: (state, payload) => {
    state.total = payload
  },
  [ADD_ADITIONAL_EFORMS]: (state, payload) => {
    const { eforms } = state

    const partialState = eforms.concat(payload)

    state.eforms = partialState
  },
  [CHANGE_EFORMS]: (state) => {
    state.eforms = []
  },
  [SET_EFORM_SELECTED]: (state, payload) => {
    state.eform = payload
  },
  [SET_INITIAL_FOLDERS]: (state, payload) => {
    state.folders = payload
  },
  [SET_ENABLE_PICKUP]: (state, payload) => {
    const { eform, eforms } = state

    const partialEform = extend({}, eform, payload.eform)
    partialEform.idpickupform = payload.idpickupform

    const partialState = map(eforms, (eform: any) => {
      if (eform.id === payload.eform.id) {
        const newObject = extend({}, eform, payload.eform)
        newObject.idpickupform = payload.idpickupform
        return newObject
      }

      return eform
    })

    state.eform = partialEform
    state.eforms = partialState
  },

  [DELETE_PICKUP]: (state, payload) => {
    const { eform, eforms } = state

    const partialEform = { ...eform }
    partialEform.pickup = false
    const partialState = map(eforms, (eform: any) => {
      if (eform.idpickupform === payload) {
        eform.pickup = false
        return eform
      }

      return eform
    })

    state.eform = partialEform
    state.eforms = partialState
  },
  [EDIT_PICKUP]: (state, payload) => {
    const { eform, eforms } = state

    const partialEform = extend({}, eform, payload)
    const partialState = map(eforms, (eform: any) => {
      if (eform.id === payload.id) {
        const newObject = extend({}, eform, payload)
        return newObject
      }

      return eform
    })

    state.eform = partialEform
    state.eforms = partialState
  },

  [UPDATE_NONPICKUP_EFORM]: (state, payload) => {
    const { eform, eforms } = state

    const partialEform = extend({}, eform, payload)

    const partialState = map(eforms, (eform: any) => {
      if (eform.id === payload.id) {
        const newObject = extend({}, eform, payload)
        return newObject
      }

      return eform
    })

    state.eform = partialEform
    state.eforms = partialState
  },

  [SET_INITIAL_EFORM_JWT]: (state, payload) => {
    state.jwt = payload
  },

  [SET_INITIAL_EFORM_CREATE]: (state, payload) => {
    state.eformCreate = payload
  },

  [SET_INITIAL_EFORM_AUTOCOMPLETE]: (state, payload) => {
    state.autocomplete = payload
  },

  [SET_INITIAL_URL_S3]: (state, payload) => {
    state.urlLogo = payload
  },

  [SET_INITIAL_EFORM_PAIS]: (state, payload) => {
    state.eformPais = payload
  }

}

export default mutations